import LightWeightInvoice from "../../Components/LightWeightCustomer/LightWeightInvoice";

export default function LightWeightInvoices(){
    return(
        <LightWeightInvoice/>
    )
}